var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNothingFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8842 48.825C51.0208 47.0425 51.6667 44.8983 51.6667 42.625C51.6667 36.1667 46.5 31 40.0417 31C33.5833 31 28.4167 36.1667 28.4167 42.625C28.4167 49.0833 33.5833 54.25 40.0417 54.25C42.2892 54.25 44.4075 53.6042 46.19 52.4933L54.25 60.4242L57.8408 56.8333L49.8842 48.825ZM40.0417 49.0833C36.4767 49.0833 33.5833 46.19 33.5833 42.625C33.5833 39.06 36.4767 36.1667 40.0417 36.1667C43.6067 36.1667 46.5 39.06 46.5 42.625C46.5 46.19 43.6067 49.0833 40.0417 49.0833ZM54.25 23.25H49.0833V18.0833H54.25V23.25ZM54.25 12.9167H49.0833V7.75H51.6667C53.0875 7.75 54.25 8.9125 54.25 10.3333V12.9167ZM49.0833 28.4942V28.4167H54.25V33.5833H54.1725C52.855 31.5425 51.1242 29.8117 49.0833 28.4942ZM43.9167 12.9167H38.75V7.75H43.9167V12.9167ZM33.5833 12.9167H28.4167V7.75H33.5833V12.9167ZM7.75 18.0833H12.9167V23.25H7.75V18.0833ZM18.0833 49.0833H23.25V54.25H18.0833V49.0833ZM7.75 28.4167H12.9167V33.5833H7.75V28.4167ZM10.3333 7.75H12.9167V12.9167H7.75V10.3333C7.75 8.9125 8.9125 7.75 10.3333 7.75ZM23.25 12.9167H18.0833V7.75H23.25V12.9167ZM7.75 49.0833H12.9167V54.25H10.3333C8.9125 54.25 7.75 53.0875 7.75 51.6667V49.0833ZM7.75 38.75H12.9167V43.9167H7.75V38.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFoundIcon);
export default __webpack_public_path__ + "static/media/nothing-found-icon.5476ae6e8e191eb96cc5162c3db99e6f.svg";
export { ForwardRef as ReactComponent };